// Module
var code = "<div class=\"please-upgrade\"> <div ng-if=\"vm.showPleaseUpgrade\" class=\"message-block message-block--alert message-block--has-dismiss\"> A new version of BarnManager is now available. Click <a ng-click=\"vm.upgrade()\">here</a> to update to the most current version. </div> </div> ";
// Exports
module.exports = code;